import Vue from 'vue'

const requireComponent = require.context(
    '../assets/svgs', true, /.+\.vue$/ // folder, subfolders, filename
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const cleanName = fileName.replace(/.+\//, '').replace(/\.\w+$/, '')
    const componentName = `SVG${cleanName}`
    // console.log(cleanName)

    Vue.component(componentName, componentConfig.default || componentConfig)
})
